export function naturalNumber(value: string | number, dec: number = 2) {
  let num = typeof value === 'string' ? Number.parseFloat(value) : value;
  const fixedFloat = num.toFixed(dec);
  return fixedFloat.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
}

function round(value: number, precision: number) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

/*
123.45 => 123.4
1,234.56 => 1.2k
12,345.67 => 12.3k
123,456.78 => 123.4k
anything over 999,999 => 1m+
*/
export function formatLongNumber(longNum: string | number) {
  let num = typeof longNum === 'string' ? Number.parseFloat(longNum) : longNum;
  let value = '';
  if (num > 1000000) {
    value = round(num / 1000000, 1).toString() + 'm';
  } else if (num > 999) {
    value = round(num / 1000, 1).toString() + 'k';
  } else {
    value = num.toFixed(1).toString();
  }
  return value;
}

export function printVaultType(vaultId: number) {
  switch (vaultId) {
    case 1:
      return 'OUSD';
    case 99:
      return 'test';
    default:
      return 'Unknown';
  }
}
